<template>
  <div class="selected-platforms-list">
    <template v-if="items.length > 0">
      <Platform
        v-for="(item, index) in items"
        :key="item.platform?.id || item.platform?.code || item.vendor?.id || index"
        :vendor="item.vendor || {}"
        :platform="item.platform || {}"
        :draggableCard="draggableCards"
        :removable="removable"
        @remove="handleRemove(index, $event)"
      />
    </template>

    <div v-else class="selected-platforms-list__empty">
      No platforms selected.
    </div>
  </div>
</template>

<script setup>
import Platform from '@/components/Platforms/Platform.vue';

const emit = defineEmits(['remove-item']);

defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  draggableCards: {
    type: Boolean,
    default: false,
  },
  removable: {
    type: Boolean,
    default: false,
  },
});

function handleRemove(index, payload) {
  emit('remove-item', {
    index,
    ...payload,
  });
}
</script>

<style lang="scss" scoped>
.selected-platforms-list {
 
  gap: 8px;
  width: 100%;
}


.selected-platforms-list__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 180px;
  width: 100%;
  border-radius: 12px;
  @include themify() {
    color: themed('body-text-color-secondary');
    background: themed('color-white-100');
    border: 1px dashed themed('color-primary-200');
  }
}
</style>
